module.exports = __webpack_public_path__ + "media/images/product_large_images/scan-f7984df620adb2e2aae50ca9c72e04a5.png";